import ajax from './ajax.js'
import { AUTH_NAME } from '@/utils/constants.js'
/**
 * 获取阿里云信息
 * @method
 * @return {Object} 返回值 包括code,msg,result
 */
export const getAliyunInfo = () =>
  ajax(AUTH_NAME.aliyunOss.getAliyunInfo, {}, 'POST')
/**
 * 获取jwttoken
 * @method
 * @return {Object} 返回值 包括code,msg,result
 */
export const getJwtToken = () => ajax(AUTH_NAME.common.getJwtToken, {}, 'POST')

/**
 * 预上传请求
 * @method
 * @param {Array} md5s 文件md5
 * @param {Number} fileType 上传文件类型 默认：0 - 模型文件， 1 - 头像文件 ，2 - 意见反馈文件 ， 3 - 评论文件
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqPreUpload2 = (md5s, fileType) =>
  ajax(AUTH_NAME.fileManage.reqPreUpload, { md5s, fileType }, 'POST')

/**
 * 创建组合模型
 * @method
 * @param {Object} groupItem 模型组信息
 * @param {Object[]} modelList 模型列表
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqCreateGroupModel = ({ groupItem, modelList }) =>
  ajax(AUTH_NAME.modelManage.createModelGroup, { groupItem, modelList }, 'POST')
/**
 * 模型组详情
 * @param id
 * @return
 */
export const reqGetModelDetail = (id, lang) =>
  ajax(AUTH_NAME.modelManage.modelGroupDetail, { id, lang }, 'POST')

/**
 * 模型组推荐列表
 * @param {*} page
 * @param {*} pageSize
 * @param {*} begin
 * @param {*} end
 * @param {*} groupName
 * @param {*} uploadSource {number} 来源类型，0全部，1用户上传，2官方上传
 * @param {*} modelId
 * @param {*} userId       用户
 * @param {*} categoryId   分类ID
 * @param {*} modelSource  {number} 来源。1：原创，2分享，3 二次创作
 * @param {*} recommendStatus {string}  枚举备注: 1-待确认 2-已推荐 3-禁止推荐
 */
export const modelRecommendList = ({
  page,
  pageSize,
  begin,
  end,
  groupName,
  uploadSource,
  modelId,
  modelSource,
  recommendStatus,
  categoryId,
  userId
}) => {
  return ajax(
    AUTH_NAME.modelManage.modelRecommendList,
    {
      page,
      pageSize,
      begin,
      end,
      groupName,
      uploadSource,
      modelId,
      modelSource,
      recommendStatus,
      categoryId,
      userId
    },
    'POST'
  )
}

/**
 * 模型组推荐排序
 * @param {*} id
 * @param {*} rank
 */
export const modelRecommendRank = ({ id, rank }) => {
  return ajax(AUTH_NAME.modelManage.modelRecommendRank, { id, rank }, 'POST')
}

/**
 * 模型组推荐取消
 * @param {*} id      {string}
 * @param {*} reason  {string}
 * @param {*} status  {Number} 4：取消推荐， 5：取消禁止推荐
 */
export const modelUnRecommend = ({ id, reason, status }) => {
  return ajax(
    AUTH_NAME.modelManage.modelUnRecommend,
    { id, reason, status },
    'POST'
  )
}

/**
 * 模型组推荐
 * @param {string} id   必须    模型组id
 * @param {number} begin  非必须  推荐开始时间， 不填默认当天
 * @param {number} end  非必须    推荐结束时间， 不填默认30天后
 * @param {string} remark 非必须  原因
 * @param {number} status 非必须  推荐枚举
 */
export const reqSetModelRecommend = ({ id, begin, end, remark, status }) => {
  return ajax(
    AUTH_NAME.modelManage.reqModelRecommend,
    { id, begin, end, remark, status },
    'POST'
  )
}

/**
 * 获取模型组分页列表
 * @method
 * @param {Number} page 分页拉取，第几页，取值从1开始
 * @param {Number} pageSize 一页显示数目
 * @param {Number} groupId 模型组id
 * @param {[Number]} copyright 版权信息
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqGroupModelList = ({
  page,
  pageSize,
  groupId,
  modelName,
  beginTime,
  endTime,
  copyright
}) =>
  ajax(
    AUTH_NAME.modelManage.modelList,
    {
      page,
      pageSize,
      modelId: groupId,
      modelName,
      begin: beginTime,
      end: endTime,
      copyright
    },
    'POST'
  )

/**
 * 模型重复列表
 * @param {Number} page
 * @param {Number} pageSize
 * @param {Number} fileId 模型id
 */
export const reqModelRepeatedList = ({ page, pageSize, fileId }) => {
  return ajax(
    AUTH_NAME.modelManage.modelRepeatedList,
    { page, pageSize, fileId },
    'POST'
  )
}

/**
 * 重复模型批量处理
 * @param {string} fileId 当前操作的模型id  （适合批量操作）
 * @param {string} fileIds 模型id集合   （适合选择或者单个处理的操作）
 */
export const reqRepeatHandle = ({ fileId, fileIds }) => {
  return ajax(AUTH_NAME.modelManage.repeatHandle, { fileId, fileIds }, 'POST')
}

// 内容分类： 文章、帖子
export const mideaType = {
  CONTENT_TYPE_TEXT: 1,
  CONTENT_TYPE_IMAGE: 2,
  CONTENT_TYPE_VIDEO: 3,
  // 4为文章，其他为帖子
  CONTENT_TYPE_LONGTEXT: 4
}

/**
 * 获取内容列表
 * @method
 * @param {Number} page 分页拉取，第几页，取值从1开始
 * @param {Number} pageSize 一页显示数目
 * @param {Number} status 状态
 * @param {String} keyword 关键字
 
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqContentList = ({ id, page, pageSize, keyword, status }) =>
  ajax(
    AUTH_NAME.contentManage.contentList,
    {
      id,
      page,
      pageSize,
      keyword,
      status
    },
    'POST'
  )

/**
 * 编辑组合模型(新增，删除，模型 修改模型组信息)
 * @method
 * @return {Object} 返回值 包括code,msg,result
 * @param {Number} groupId 模型组id
 * hasCoversFileKey 是否修改封面图
 */
export const reqEditGroup = ({ groupItem, modelList }) =>
  ajax(
    AUTH_NAME.modelManage.modelGroupEdit,
    {
      groupItem,
      modelList
    },
    'POST'
  )
/**
 * 根据条件查询分类列表
 * @method
 * @param {number} type 类型
 * @param { number } status  2-审核通过 3-审核失败 4-删除
 * @return {Object} 返回值 包括code,msg,result
 */
// 换了接口，结构都换了 这里统一处理程之前结构
export const reqGetCategoryList = async ({ type, fatherId }) => {
  const respond = await ajax(
    AUTH_NAME.categoryManage.listAll,
    {
      types: type,
      fatherId: fatherId ? fatherId + '' : undefined
    },
    'POST'
  )
  const { code, msg, result } = respond
  if (code === 0) {
    const all = result.all
    const list = all.length && all[0].children ? all[0].children : []
    const newRespond = new Promise(resolve =>
      resolve({ code, msg, result: { list } })
    )
    return newRespond
  } else {
    return new Promise(resolve => resolve(respond))
  }
}
/**
 * 得到标签列表
 * @method
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqGetTagList = ({
  page,
  pageSize,
  keyword,
  isRecommend,
  tagNames,
  recObjs,
  sortType,
  isAsc
}) =>
  ajax(
    AUTH_NAME.tagsManage.tagList,
    {
      page,
      pageSize,
      keyword,
      isRecommend,
      tagNames,
      recObjs,
      sortType,
      isAsc
    },
    'POST'
  )

/**
 * 搜索标签列表（和reqGetTagList的区别在搜索条件和result(list 只有name和count)为简易版）
 * @method
 * @return {Object} 返回值 包括code,msg,result
 */
export const comSearchTag = ({ page, pageSize, keyword }) =>
  ajax(
    AUTH_NAME.tagsManage.searchTag,
    {
      page,
      pageSize,
      keyword
    },
    'POST'
  )

// 创建视频凭证
export const reqPreUploadVideo = ({ title, fileName }) =>
  ajax(
    AUTH_NAME.circleManage.preUploadVideo,
    {
      title,
      fileName
    },
    'POST'
  )
/**
 * 圈子探测
 * @method
 * @param {String} name  名称精确匹配
 * @param {String} keyword  关键字模糊匹配
 
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqDetectCircle = ({ page, pageSize, name, keyword }) =>
  ajax(
    AUTH_NAME.circleManage.circleDetect,
    { page, pageSize, name, keyword },
    'POST'
  )
/**
 * 创建贴子
 * @method
 * @param {string} id 帖子id
 * @param {string} circleId 圈子id
 * @param {String} content 贴子内容
 * @param {Object} media 媒体
 * @param {Object} tags 标签
 * @param {Object} location 地址
 * @param {Integer} mediaType
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqCreateContent = ({
  id,
  circleId,
  content,
  media,
  title,
  tags,
  mediaType,
  location,
  modelGroupId,
  gradeValue
}) =>
  ajax(
    AUTH_NAME.circleManage.createPost,
    {
      item: {
        id,
        groupId: circleId,
        content,
        media,
        title,
        tags,
        mediaType,
        location,
        modelGroupId,
        gradeValue
      }
    },
    'POST'
  )
/**
 * 创建内容
 * @method
 * @param {string} id 帖子id
 * @param {string} circleId 圈子id
 * @param {String} content 贴子内容
 * @param {Object} media 媒体
 * @param {Object} tags 标签
 * @param {Object} location 地址
 * @param {Integer} mediaType
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqAddContent = ({
  id,
  title,
  content,
  media,
  tags,
  mediaType,
  channelId,
  location,
  modelGroupId,
  gradeValue,
  groupId,
  columnId,
  widgetType,
  description,
  widgetId,
  publishTime,
  delyTime,
  widgetIdToWidgetPay,
  gcodeInfo,
  blogIds,
  atUserIds,
  isDraft,
  isDraftStatus,
  modelGroupIds,
  keysword
}) => {
  let url = ''
  if (id) {
    if (isDraft) {
      url = AUTH_NAME.contentManage.draftEdit
    } else {
      if (isDraftStatus) {
        url = AUTH_NAME.contentManage.pushContent
      } else {
        url = AUTH_NAME.contentManage.contentEdit
      }
    }
  } else {
    url = isDraft
      ? AUTH_NAME.contentManage.draftAdd
      : AUTH_NAME.contentManage.contentAdd
  }
  return ajax(
    url,
    {
      id,
      title,
      content,
      media,
      tags,
      mediaType,
      channelId,
      location,
      modelGroupId,
      gradeValue,
      groupId,
      columnId,
      widgetType,
      description,
      widgetId,
      widgetIdToWidgetPay,
      publishTime,
      delyTime,
      gcodeInfo,
      blogIds,
      atUserIds,
      isDraft,
      modelGroupIds,
      keysword
    },
    'POST'
  )
}

/**
 * 创建圈子
 * @method
 * @param {string} id 圈子id
 * @param {String} name 圈子名称
 * @param {String} avatar 头像
 * @param {String} backColor 主题色
 * @param {String} description 描述
 * @param {Object} location 地址
 * @param {Boolean} isAllowComment 是否允许参与
 * @param {Integer} classId 类id
 *
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqCreateCircle = ({
  id,
  name,
  avatar,
  backColor,
  description,
  location,
  isAllowComment,
  categoryId,
  groupType
}) =>
  ajax(
    AUTH_NAME.circleManage.createCircle,
    {
      item: {
        id,
        name,
        avatar,
        backColor,
        description,
        location,
        isAllowComment,
        categoryId,
        groupType
      }
    },
    'POST'
  )

/**
 * 搜索条件用户搜索
 * @method
 * @param {String} keyword 关键字
 * @param {String} account 账号 精确查找
 * @param {Boolean} needDel 是否返回已注销账户
 * @param {Integer} page
 * @param {Integer} pageSize
 * @return {Object} 返回值 包括code,msg,result
 */

export const comSearchUser = ({ keyword, account, needDel, pageSize, page }) =>
  ajax(
    AUTH_NAME.others.searchUser,
    {
      keyword,
      account,
      needDel,
      page,
      pageSize
    },
    'POST'
  )
/**
 * 用户详情
 * @param { number } userId
 * @return { object }
 */
export const reqUserDetail = userId => {
  return ajax(AUTH_NAME.userAdmin.detail, { userId: +userId }, 'POST')
  // const { code, msg, result } = respond
}

/**
 * 操作记录列表
 * @param { number } page
 * @param { number } pageSize
 * @param { number } moduleId 操作模块ID
 * @param { string } opObjId 操作对象ID
 * @param { number } userId 操作人ID
 * @param { string } opAction 操作类型
 * @param { number } begin 操作时间起
 * @param { number } end 操作时间止
 * @return { object }
 */
export const reqOperateRecord = ({
  page,
  pageSize,
  moduleId,
  opObjId,
  userId,
  opAction,
  begin,
  end
}) =>
  ajax(
    AUTH_NAME.others.operationRecord,
    { page, pageSize, moduleId, opObjId, userId, opAction, begin, end },
    'POST'
  )

/**
 * 操作记录列表 java
 * @param { number } page
 * @param { number } pageSize
 * @param { string } targetId
 * @return { object }
 */
export const reqOperateRecordJava = ({ page, pageSize, targetId }) =>
  ajax(
    AUTH_NAME.others.operationRecordJava,
    { page, pageSize, targetId },
    'GET'
  )
/**
 * 圈子详情
 * @param { string } id
 *
 */
export const reqCircleDetail = id =>
  ajax(AUTH_NAME.circleManage.circleDetail, { id }, 'POST')

// /**
//  * 获取模型分类列表
//  * @method
//  * @return {Object} 返回值 包括code,msg,result
//  */
// export const reqGetCategories = osLang =>
//   ajax('/api/model/category/list', { osLang }, 'POST')

/**
 * 修改密码
 * @method
 * @param {String} oldPassword
 * @param {String} newPassword
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqEditPassword = (oldPassword, newPassword) =>
  ajax(AUTH_NAME.others.editPwd, { oldPassword, newPassword }, 'POST')
/**
 * 发布评论
 * @method
 * @param { Object } item
 * @return { Object }
 */
export const reqCommentPost = ({
  targetId,
  type,
  content,
  parentId,
  replyId,
  pictures,
  atUserIds,
  robotToken,
  robotUserId
}) => {
  // 普通评论
  let url = AUTH_NAME.commentManage.commentPost
  if (robotToken) {
    // 机器人评论
    url = AUTH_NAME.commentManage.commentPost2
  }
  return ajax(
    url,
    {
      item: {
        targetId,
        type,
        content,
        parentId,
        replyId,
        pictures,
        atUserIds,
        robotToken,
        robotUserId
      }
    },
    'POST'
  )
}

/**
 * 机器人获取token
 * @method
 * @param { Object } item
 * @return { Object }
 */
export const reqGetRobotToken = ({ userId }) =>
  ajax(AUTH_NAME.commentManage.robotToken, { userId }, 'POST')

/**
 * 请求频道列表
 * @method
 * @param {Object}
 * @return {Object} 返回值 包括code,msg,result
 */
export const getChannelList = ({ nameCn, status, page, pageSize }) =>
  ajax(
    AUTH_NAME.channelManage.channelList,
    { nameCn, status, page, pageSize },
    'POST'
  )
// 内容详情
export const reqContentDetail = ({ id }) =>
  ajax(AUTH_NAME.contentManage.contentDetail, { id }, 'POST')

/**
 * 根据条件查询所有分类列表
 * @method
 * @param {number} type 类型
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqGetALLCateList = ({ types }) =>
  ajax(
    AUTH_NAME.categoryManage.listAll,
    {
      types
    },
    'POST'
  )
/**
 * 请求所有分类列表
 * @method
 * @param {Object}
 * @return {Object} 返回值 包括code,msg,result
 */
export const getAllCategoryList = () =>
  ajax(AUTH_NAME.categoryManage.listAll, {}, 'POST')
/**
 * 新增切片
 * @method
 * @param {Object}
 * @return {Object} 返回值 包括code,msg,result
 */
export const reqAddSlice = ({
  id,
  name,
  thumbnail,
  covers,
  printTime,
  type,
  filamentLen,
  filekey,
  productCovers,
  description,
  modelInfo,
  modelFileIds,
  parameter,
  isPublic,
  content,
  explicitKey,
  filamentVolume
}) => {
  const url = id ? AUTH_NAME.sliceManage.edit : AUTH_NAME.sliceManage.add
  const params = {
    id,
    name,
    thumbnail,
    covers,
    printTime,
    type,
    filamentLen,
    filekey,
    productCovers,
    description,
    modelInfo,
    modelFileIds,
    parameter,
    isPublic,
    content,
    explicitKey,
    filamentVolume
  }
  return ajax(url, id ? params : { list: [params] }, 'POST')
}

/**
 * 根据条件查询皮肤列表
 * @method
 * @param {number} begin 开始时间
 * @param {number} end 结束时间
 * @param {number} pageSize 页数
 * @param {number} page 页码
 * @param {number} userId 用户id
 * @param {string} keyword 关键字
 * @return {Object} 返回值 包括code,msg,result
 */
export const getSkinList = ({ begin, end, keyword, page, pageSize, userId }) =>
  ajax(
    AUTH_NAME.resinSkinManage.list,
    {
      begin,
      end,
      keyword,
      page,
      pageSize,
      userId
    },
    'POST'
  )

/**
 * 新建、编辑皮肤
 * @method
 * @param {number} id
 * @param {number} fileUrl 文件URl
 * @param {string} name 皮肤名称
 * @param {number} size 文件大小
 * @return {Object} 返回值 包括code,msg,result
 */
export const submitSkinPut = ({ fileUrl, fileName, id, name, size }) =>
  ajax(
    AUTH_NAME.resinSkinManage.edit,
    {
      item: {
        fileUrl,
        fileName,
        id,
        name,
        size
      }
    },
    'POST'
  )
/**
 * 操作皮肤：排序、上下架
 * @method
 * @param {number} id
 * @param {number} status 状态
 * @param {number} sort 排序数值
 * @return {Object} 返回值 包括code,msg,result
 */
export const setSkinOperate = ({ id, status, sort }) =>
  ajax(
    AUTH_NAME.resinSkinManage.operate,
    {
      id,
      status,
      sort
    },
    'POST'
  )

/**
 * 修改模型18禁级别
 * @param {string} id
 * @param {string} maturityRating 状态 general,restricted
 * @return {Object} 返回值 包括code,msg,result
 */
export const opMaturityRating = ({ id, maturityRating }) =>
  ajax(
    AUTH_NAME.modelManage.opMaturityRating,
    {
      id,
      maturityRating
    },
    'POST'
  )

/**
 * 异步任务新增
 * http://yapi.crealitygroup.com/project/16/interface/api/15036
 */
export const addAsyncTaskManage = params => {
  return ajax(AUTH_NAME.asyncTaskManage.add, params, 'POST')
}

/**
 * 有效用户验证
 * http://yapi.crealitygroup.com/project/16/interface/api/17145
 * userIds  integer [] 批量用户id,不超过5000
 */
export const validUsers = params => {
  return ajax(AUTH_NAME.common.validUsers, params, 'POST')
}

/**
 * @description 获取用户最后一次行为
 * @param { Number } uid
 */
export const userLastActive = uid => {
  return ajax(AUTH_NAME.common.userLastActive, { uid }, 'POST')
}

/**
 * 设备历史记录 设备激活记录
 * @method
 * @param {String} dn
 */
export const reqDeviceHistory = dn =>
  ajax(AUTH_NAME.deviceManage.deviceRegisterRecord, { dn }, 'POST')

/**
 * @description 模型转3mf打印机列表
 */
export const reqPrinterList = () =>
  ajax(AUTH_NAME.modelManage.printerList, {}, 'POST')

/**
 * @description 创建模型转3mf任务
 * @param { Object } payload 参数对象
 * @param { Number } payload.rank 权重
 * @param { Array } payload.printers 打印机列表
 * @param { String } payload.bulkId 批量模型列表ID
 */
export const reqCreateTo3mf = ({ rank, printers, bulkId }) =>
  ajax(AUTH_NAME.modelManage.createTo3mf, { rank, printers, bulkId }, 'POST')

/**
 * @description 模型转3mf任务列表
 * @param { Object } payload 参数对象
 * @param { Number } payload.page 页码
 * @param { Number } payload.pageSize 页码
 * @param { Number= } payload.begin 页码
 * @param { Number= } payload.end 页码
 * @param { Number= } payload.state 页码
 * @param { String= } payload.modelId 页码
 */
export const reqListTo3mf = ({ page, pageSize, state, modelId, begin, end }) =>
  ajax(
    AUTH_NAME.modelManage.listTo3mf,
    { page, pageSize, state, modelId, begin, end },
    'POST'
  )

/**
 * @description 转3mf任务重试
 * @param { Object } payload  参数对象
 * @param { String } payload.id  任务ID，如果isAll为false，该字段必填
 * @param { Boolean } payload.isAll  是否重试全部任务
 */
export const reqRetryTo3mf = ({ id, isAll }) =>
  ajax(AUTH_NAME.modelManage.retryTo3mf, { id, isAll }, 'POST')

/**
 * @description 转3mf任务删除
 * @param { Object } payload  参数对象
 * @param { String } payload.id  任务ID
 */
export const reqDelTo3mf = ({ id }) =>
  ajax(AUTH_NAME.modelManage.delTo3mf, { id }, 'POST')

/**
 * @description 转3mf任务权重编辑
 * @param { Object } payload  参数对象
 * @param { String } payload.id  任务ID
 * @param { Number } payload.rank  任务ID
 */
export const reqRankTo3mf = ({ id, rank }) =>
  ajax(AUTH_NAME.modelManage.rankTo3mf, { id, rank }, 'POST')

/**
 * @description 转3mf任务统计
 */
export const reqStatiscTo3mf = () =>
  ajax(AUTH_NAME.modelManage.statiscTo3mf, {}, 'POST')

/**
 * 用户分层标签树
 */
export const reqUserLayerTags = () => {
  return ajax(AUTH_NAME.userAdmin.userLayerTags, {}, 'POST')
}

/**
 * 分层标签用户列表
 * @param { Number } page
 * @param { Number } pageSize
 * @param { Number } userId  	用户id
 * @param { Number } begin  开始时间
 * @param { Number } end  结束时间
 * @param { string[] } tagIds  标签id列表
 */
export const reqLayerUserList = ({
  page,
  pageSize,
  userId,
  begin,
  end,
  tagIds
}) => {
  return ajax(
    AUTH_NAME.userAdmin.layerUserList,
    { page, pageSize, userId, begin, end, tagIds },
    'POST'
  )
}

/**
 * 查询符合用户标签的用户数量
 * @param { Number } regBegin  注册-开始时间
 * @param { Number } regEnd  注册-结束时间
 * @param { string[] } tagIds  标签id列表
 */
export const reqLayerUserCount = ({ tagIds, regBegin, regEnd }) => {
  return ajax(
    AUTH_NAME.userAdmin.layerUserCount,
    { tagIds, regBegin, regEnd },
    'POST'
  )
}

/**
 * 请求接口批量
 */
export const reqBatch = (params, url) => {
  return ajax(url, params, 'POST')
}
